@if (isPdfViewer()) {
  <ldw-pdf-viewer [document]="document" [downloadAllowed]="downloadAllowed()"
  [pageNumber]=pageNumber [search]='search'  [printAllowed]="printingAllowed()"></ldw-pdf-viewer>
}
@if (isPdftEditor()) {
  <ldw-pdft-editor
  [planningJob]="selectedPlanningJob()?.name"
  [document]="document" [downloadAllowed]="downloadAllowed()"
    [doCloseNotNavigate]="doCloseNotNavigate"  [isReadOnly]="isReadOnly()"
  [pageNumber]=pageNumber [pageZoom]=pageZoom [search]='search' [printAllowed]="printingAllowed()" #pdftEditor></ldw-pdft-editor>
}
